<template>
  <v-container fluid>
    <page-header> Email Settings </page-header>
    <v-card v-if="account">
      <v-card-text>
        <v-form ref="form">
          <v-text-field v-model="account.smtpHost" label="Host" />
          <v-text-field v-model="account.smtpPort" label="Port" />
          <v-text-field v-model="account.smtpFrom" label="Default From Email" />
          <v-text-field
            autocomplete="off"
            aria-autocomplete="list"
            v-if="account.smtpAuth"
            v-model="account.smtpUserName"
            label="User Name"
          />
          <v-text-field
            autocomplete="off"
            aria-autocomplete="list"
            type="password"
            v-if="account.smtpAuth"
            v-model="account.smtpPassword"
            label="Password"
          />
          <v-checkbox
            v-model="account.smtpAuth"
            label="Require Authentication"
            @click="handleAuthChange"
          />
          <v-checkbox v-model="account.smtpStarttlsEnable" label="Enable TLS" />
          <v-checkbox v-model="account.smtpDebug" label="Debug Email" />

          <v-btn color="primary" @click="saveSettings">Save</v-btn>
        </v-form>

        <div class="my-6 text-right" v-if="account && account.smtpHost">
          <v-btn @click="testConnection"> Test Connection </v-btn>
        </div>

        <div class="text-center my-4" v-if="connectionEstablished">
          <v-divider class="my-4" />
          <v-select
            :items="emailTypes"
            label="Choose a sample email type"
            v-model="selectedEmailType"
          />
          <v-btn
            :disabled="!selectedEmailType"
            color="primary"
            @click="sendSampleEmail(selectedEmailType)"
          >
            Send Sample Email</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { rules } from "@/store/util/rules.js";
const PageHeader = () => import("@/components/common/PageHeader.vue");

export default {
  data: () => {
    return {
      account: null,
      rules,
      emailTypes: [
        "Send sample receipt",
        "Send sample Invoice",
        "Send sample Invoice Overdue",
        "Send sample Form submission confirmation",
        "Send sample Form submission alert",
      ],
      selectedEmailType: "",
      connectionEstablished: false,
    };
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading", "globalCenter"]),
  },
  mounted() {
    this.initAccount().then((account) => {
      this.account = account;
      if (!this.account.timezone) {
        this.account.timezone = "America/New_York"; //Default
      }
    });
  },
  components: {
    PageHeader,
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    async initAccount() {
      return await this.$axios
        .get("/account/get-by-id", {
          params: {
            accountId: this.globalCenter ? this.globalCenter.accountId : null,
          },
        })
        .then((resp) => {
          return resp.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading account from server");
        });
    },

    async saveSettings() {
      await this.$axios
        .post("/account/info", this.account)
        .then(() => {
          console.log("updated account");
          this.addSuccessMessage("Account updated");
        })
        .catch((error) => {
          this.addErrorMessage(error.message || "Error saving email settings");
        });
    },
    async sendSampleEmail(emailType) {
      // Implement the send sample email logic here
      console.log("sending sample email: " + emailType);
    },
    testConnection() {
      this.$axios
        .post("/account/validate-smtp", null, {
          params: { accountId: this.account.id },
        })
        .then(() => {
          this.connectionEstablished = true;
          this.addSuccessMessage("Connection Successful");
        })
        .catch((error) => {
          this.addErrorMessage(
            error.data ||
              "Unable to establish email connection using the configurations provided"
          );
        });
    },
    handleAuthChange(){
      if(!this.account.smtpAuth){
        this.account.smtpUserName = null;
        this.account.smtpPassword = null;
      }
    }
  },
};
</script>
